<template>
  <v-card flat class="px-5">
    <ValidationObserver ref="observer">
      <template v-for="field in fields" >

        <div :key="field.title" class="text-subtitle-1 text-button my-7">
          {{ field.title }}
        </div>
        <v-row dense>
          <v-col cols="4" v-for="detail in field.details" :key="detail.name">
            <ValidationProvider
              :name="detail.label"
              :rules="detail.rules"
              events="['blur']"
              v-slot="{ errors }"
            >
              <v-select
                v-if="detail.type ==='select'"
                :label="detail.label"
                v-model="details[detail.value]"
                outlined
                dense
                :items="detail.items"
                :error-messages="errors"
              />
              <v-text-field
                v-else-if="detail.type ==='date'"
                :label="detail.label"
                type="date"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
              <v-text-field
                v-else
                :label="detail.label"
                v-model="details[detail.value]"
                outlined
                dense
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

        </v-row>
      </template>
    </ValidationObserver>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      details: {},
      fields: [ 
        {
          title: '',
          details: [ 
            {
              label: "Employer",
              value: "employer",
              rules: ""
            },
            {
              label: "Sector",
              value: "sector",
              rules: ""
            },
            {
              label: "Industry",
              value: "industry",
              rules: ""
            },
            {
              type: 'select',
              items: ['Employed','Self-Employed','Student','Unemployed'],
              label: "Employment Status",
              value: "employmentStatus",
              rules: ""
            }
          ]
        }
      ]
    }
  },

  methods: {
    clear() {
      this.details = {}
    },

    async validate() {
      return this.$refs.observer.validate();
    },

    submit() {
      this.$emit('submit', this.details)
    }
  }
}

</script>